<template>
  <div class="final">
    <h2 class="large-title">Final Balances</h2>
    <div class="final__content">
      <div :class="['calendar']">
        <label class="small-font">End Date</label>
        <v-date-picker
          v-model='endDate'
          :max-date='new Date()'
          :popoverVisibility="'focus'"
          :theme-styles='themeStyles'
          class='date-input'>
          <input
            class="calendar-start"
            placeholder= "DD/MM/YYYY"
            type='text'
            slot-scope='{ inputValue, updateValue }'
            :value='inputValue'
            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
        </v-date-picker>
      </div>
      <!-- <button class="btn-large secondary" @click="download">Download</button> -->
    </div>
      <button class="btn-large secondary" @click="download">Download</button>
  </div>
</template>

<script>
import Loading from '@/components/Loading/Secondary'
import calendar from 'v-calendar'
import moment from 'moment';
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-final_balance',
  components: {
    'v-calendar': calendar,
  },
  props: {

  },
  data() {
    return {
      endDate: new Date(),
      singleDate: new Date(),
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
    }
  },
  computed: {
    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    download() {
      let endDate = moment(this.endDate).format('YYYY-MM-DD')
      window.location = apiV2.FinalTransactions(endDate)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>